import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import BlueDotPoint from '@/assets/icons/blue-dot-point.svg';
import { Typography } from '@/components/ui/typography';

function HiringGoalPill() {
  return (
    <div className="flex h-6 w-20 flex-none grow-0 flex-row items-center justify-center gap-1 rounded-full bg-blue-50 px-2">
      <img src={BlueDotPoint} alt="View" />
      <Typography variant="small1" className="!text-blue-800">
        <FormattedMessage defaultMessage="Viewing" />
      </Typography>
    </div>
  );
}
export { HiringGoalPill };
